import * as React from 'react'
import { Oval } from 'react-loader-spinner'

import { colors } from '../../themes/Colors'

interface LoaderProps {
  height?: number
  width?: number
  type?: string
  color?: string
  className?: string
}

class Loader extends React.Component<LoaderProps> {
  static defaultProps = {
    type: 'Oval',
    color: colors.lightDarkBlue,
    height: 24,
    width: 24
  }

  override render() {
    const { height, width, type, color, ...other } = this.props
    return (
      <Oval
        className="react-loader"
        color={color}
        secondaryColor={color}
        height={height}
        width={width}
        {...other}
      />
    )
  }
}

export { Loader }
